var _excluded = ["component", "value", "onChange", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Box } from '@creditas-ui/layout';
import { useRadioGroup } from './hooks';

var RadioGroup = _ref => {
  var {
    component = 'div',
    value = '',
    onChange,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    selectedValue,
    handleOnChange
  } = useRadioGroup({
    value,
    onChange
  });
  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    as: component
  }), React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    checked: selectedValue === child.props.value,
    onChange: handleOnChange
  })));
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map